import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Icon } from "@mui/material";

import React from "react";

interface Props {
  open: boolean;
  product: string;
  handleClose: () => void;
  handleDelete: () => void;
}

const DeleteProductDialog = (props: Props) => {
  const { open, product, handleClose, handleDelete } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      scroll="body"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        Delete Product
        <IconButton
          size="small"
          onClick={handleClose}
          sx={{ position: "absolute", right: "1rem", top: "1rem" }}
        >
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography textAlign="center">
          Are you sure you want this delete product?
        </Typography>
        <Typography textAlign="center" color="error" fontWeight={700}>
          {product}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          size="large"
          type="submit"
          sx={{ mr: 2 }}
          variant="contained"
          onClick={handleDelete}
        >
          Yes
        </Button>
        <Button
          size="large"
          color="secondary"
          variant="outlined"
          onClick={handleClose}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteProductDialog
